var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 32,
    viewBox: "0 0 144 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.86795 16L0.288574 12.1983L5.13795 3.80173L11.7211 7.59687L11.7249 0H21.4237L21.4274 7.59687L28.0106 3.80173L32.86 12.1983L26.2806 16L32.86 19.8017L28.0106 28.1983L21.4274 24.4031L21.4237 32H11.7249L11.7211 24.4031L5.13795 28.1983L0.288574 19.8017L6.86795 16Z",
    fill: "#84CAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.86 0C68.6138 0 65.1717 3.44217 65.1717 7.68831C65.1717 8.03259 64.8926 8.31169 64.5483 8.31169C60.3022 8.31169 56.86 11.7538 56.86 16C56.86 20.2462 60.3022 23.6884 64.5483 23.6884C64.8926 23.6884 65.1717 23.9674 65.1717 24.3116C65.1717 28.5578 68.6138 32 72.86 32C77.1061 32 80.5484 28.5578 80.5484 24.3116C80.5484 23.9674 80.8274 23.6884 81.1716 23.6884C85.4178 23.6884 88.86 20.2462 88.86 16C88.86 11.7538 85.4178 8.31169 81.1716 8.31169C80.8274 8.31169 80.5484 8.03259 80.5484 7.68831C80.5484 3.44217 77.1061 0 72.86 0Z",
    fill: "#FFC3BE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.924 0H143.647C144.534 7.11693 135.966 8.82823 135.966 16C135.966 23.1718 144.534 24.883 143.647 32H112.924C112.037 24.883 120.605 23.1718 120.605 16C120.605 8.82823 112.037 7.11693 112.924 0Z",
    fill: "#FDB022"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24);
export default __webpack_public_path__ + "static/media/2-4.249e3b352687402494347713da087e35.svg";
export { ForwardRef as ReactComponent };